export type TRetirementReasonId = number;

export const OTHER_RETIREMENT_REASON_NAME = 'Other';

export interface RetirementReason {
  id: TRetirementReasonId;
  name: string;
  visible_to_equipment: boolean;
  visible_to_facilities: boolean;
}
